import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class TradingEnvironment {

  @JsonProperty()
  id: string | undefined;
  @JsonProperty()
  code: string | undefined;
  @JsonProperty()
  description: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  clearingHouse: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
